import React from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useContext } from "react";
import AuthContext from "../Context/AuthContext";
import NavContext from "../Context/NavContext";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { Link } from "react-router-dom";
import { AiOutlineLogout, AiOutlineSetting, AiOutlineFullscreen } from 'react-icons/ai'
import { BsQuestionCircle } from 'react-icons/bs';
// import Cookies from 'js-cookie'
export const Header = () => {
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const { isLoggedIn, setIsLoggedIn } = useContext(AuthContext);
  const { sidebar, setSidebar } = useContext(NavContext);

  const navigate = useNavigate();

  const logout =() => {
   
    localStorage.clear();
    removeCookie('JWTcookie', { path: "/" });
    
      setIsLoggedIn(false);
        
    if (isLoggedIn) {
      navigate('/')
    }

  }
  


  return (
    <>
      <div className="header" >

        <div className="navbar-btn">
          {sidebar ?
            (

              <Link to='#' className='navbar-icon' onClick={() => setSidebar(false)}>
                <AiIcons.AiOutlineClose size={26} />
              </Link>
            ) : (
              <Link to='#' className='navbar-icon' onClick={() => setSidebar(true)}>
                <FaIcons.FaBars size={26} />
              </Link>
            )
          }
        
        </div>

           <div className="headercontent">
          <Link to="/"><img className="logo-img" src='/logo.png' alt="snaxsmart" /></Link>
        </div>

        <div className="headercontent">

          <div className="icon-div"><AiOutlineSetting className="settings-icon" /></div>
          <div className="icon-div"><BsQuestionCircle className="settings-icon" /></div>
          <div className="icon-div"><AiOutlineFullscreen className="settings-icon" /></div>
          <div className="icon-div"><AiOutlineLogout className="logout-icon" onClick={logout} /></div>
        </div>

      </div>
    </>
  );
}

